import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginationControlsComponent } from '../pagination-controls/pagination-controls.component';

@Component({
  selector: 'app-section-shell',
  standalone: true,
  imports: [PaginationControlsComponent],
  templateUrl: './section-shell.component.html',
  styleUrl: './section-shell.component.scss'
})
export class SectionShellComponent {
  @Input() sectionId = '';
  @Input() sectionClass = '';
  @Input() sectionTitle = '';
  @Input() displayResults = 0;

  @Input() pageSizeOptions: number[] = [];
  @Input() pageSize = 4;
  @Input() currentPage = 1;
  @Input() totalPages = 1;
  @Input() canGoPrev = false;
  @Input() canGoNext = false;

  @Output() pageSizeChange = new EventEmitter<string>();
  @Output() prevPage = new EventEmitter<void>();
  @Output() nextPage = new EventEmitter<void>();

  get sectionClassList(): string {
    return this.sectionClass ? `section-shell ${this.sectionClass}` : 'section-shell';
  }
}
